// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=none"
// @generated from file police/v1/police.proto (package police.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file police/v1/police.proto.
 */
export const file_police_v1_police: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Npc is the wire shape of a single NPC. Fields mirror the columns of the
 * `npcs` table that the client cares about; internal columns (last_tick_at,
 * expires_at) stay server-side.
 *
 * @generated from message police.v1.Npc
 */
export type Npc = Message<"police.v1.Npc"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * "guardian" | "responder"
   *
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: string state = 3;
   */
  state: string;

  /**
   * @generated from field: int32 health = 4;
   */
  health: number;

  /**
   * @generated from field: int32 max_health = 5;
   */
  maxHealth: number;

  /**
   * @generated from field: double lat = 6;
   */
  lat: number;

  /**
   * @generated from field: double lng = 7;
   */
  lng: number;

  /**
   * empty for guardians
   *
   * @generated from field: string target_player_id = 8;
   */
  targetPlayerId: string;

  /**
   * @generated from field: int32 attack_range_m = 9;
   */
  attackRangeM: number;
};

/**
 * Describes the message police.v1.Npc.
 * Use `create(NpcSchema)` to create a new message.
 */
export const NpcSchema: GenMessage<Npc> = /*@__PURE__*/
  messageDesc(file_police_v1_police, 0);

/**
 * @generated from message police.v1.ListNpcsInCellRequest
 */
export type ListNpcsInCellRequest = Message<"police.v1.ListNpcsInCellRequest"> & {
  /**
   * @generated from field: string s2_cell = 1;
   */
  s2Cell: string;
};

/**
 * Describes the message police.v1.ListNpcsInCellRequest.
 * Use `create(ListNpcsInCellRequestSchema)` to create a new message.
 */
export const ListNpcsInCellRequestSchema: GenMessage<ListNpcsInCellRequest> = /*@__PURE__*/
  messageDesc(file_police_v1_police, 1);

/**
 * @generated from message police.v1.ListNpcsInCellResponse
 */
export type ListNpcsInCellResponse = Message<"police.v1.ListNpcsInCellResponse"> & {
  /**
   * @generated from field: repeated police.v1.Npc npcs = 1;
   */
  npcs: Npc[];
};

/**
 * Describes the message police.v1.ListNpcsInCellResponse.
 * Use `create(ListNpcsInCellResponseSchema)` to create a new message.
 */
export const ListNpcsInCellResponseSchema: GenMessage<ListNpcsInCellResponse> = /*@__PURE__*/
  messageDesc(file_police_v1_police, 2);

/**
 * @generated from message police.v1.ListNpcsNearRequest
 */
export type ListNpcsNearRequest = Message<"police.v1.ListNpcsNearRequest"> & {
  /**
   * @generated from field: double lat = 1;
   */
  lat: number;

  /**
   * @generated from field: double lng = 2;
   */
  lng: number;

  /**
   * @generated from field: double radius_m = 3;
   */
  radiusM: number;

  /**
   * 0 = server default cap
   *
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message police.v1.ListNpcsNearRequest.
 * Use `create(ListNpcsNearRequestSchema)` to create a new message.
 */
export const ListNpcsNearRequestSchema: GenMessage<ListNpcsNearRequest> = /*@__PURE__*/
  messageDesc(file_police_v1_police, 3);

/**
 * @generated from message police.v1.BribePoliceRequest
 */
export type BribePoliceRequest = Message<"police.v1.BribePoliceRequest"> & {
};

/**
 * Describes the message police.v1.BribePoliceRequest.
 * Use `create(BribePoliceRequestSchema)` to create a new message.
 */
export const BribePoliceRequestSchema: GenMessage<BribePoliceRequest> = /*@__PURE__*/
  messageDesc(file_police_v1_police, 4);

/**
 * @generated from message police.v1.BribePoliceResponse
 */
export type BribePoliceResponse = Message<"police.v1.BribePoliceResponse"> & {
  /**
   * @generated from field: int64 clean_cash_paid = 1;
   */
  cleanCashPaid: bigint;

  /**
   * @generated from field: int32 new_heat = 2;
   */
  newHeat: number;

  /**
   * @generated from field: int64 new_clean_cash = 3;
   */
  newCleanCash: bigint;
};

/**
 * Describes the message police.v1.BribePoliceResponse.
 * Use `create(BribePoliceResponseSchema)` to create a new message.
 */
export const BribePoliceResponseSchema: GenMessage<BribePoliceResponse> = /*@__PURE__*/
  messageDesc(file_police_v1_police, 5);

/**
 * @generated from message police.v1.PayBailRequest
 */
export type PayBailRequest = Message<"police.v1.PayBailRequest"> & {
};

/**
 * Describes the message police.v1.PayBailRequest.
 * Use `create(PayBailRequestSchema)` to create a new message.
 */
export const PayBailRequestSchema: GenMessage<PayBailRequest> = /*@__PURE__*/
  messageDesc(file_police_v1_police, 6);

/**
 * @generated from message police.v1.PayBailResponse
 */
export type PayBailResponse = Message<"police.v1.PayBailResponse"> & {
  /**
   * @generated from field: int64 clean_cash_paid = 1;
   */
  cleanCashPaid: bigint;

  /**
   * @generated from field: int64 new_clean_cash = 2;
   */
  newCleanCash: bigint;
};

/**
 * Describes the message police.v1.PayBailResponse.
 * Use `create(PayBailResponseSchema)` to create a new message.
 */
export const PayBailResponseSchema: GenMessage<PayBailResponse> = /*@__PURE__*/
  messageDesc(file_police_v1_police, 7);

/**
 * @generated from message police.v1.GetPublicConfigRequest
 */
export type GetPublicConfigRequest = Message<"police.v1.GetPublicConfigRequest"> & {
};

/**
 * Describes the message police.v1.GetPublicConfigRequest.
 * Use `create(GetPublicConfigRequestSchema)` to create a new message.
 */
export const GetPublicConfigRequestSchema: GenMessage<GetPublicConfigRequest> = /*@__PURE__*/
  messageDesc(file_police_v1_police, 8);

/**
 * PublicConfig is the read-only projection of police_config the client is
 * allowed to see. Nothing here is a request the client can make — every other
 * dial in the row stays admin-only, and the server re-checks the ones it
 * enforces regardless of what the client believes.
 *
 * @generated from message police.v1.PublicConfig
 */
export type PublicConfig = Message<"police.v1.PublicConfig"> & {
  /**
   * How many seconds a killed body — a police NPC or another player — stays on
   * the ground before the client removes it.
   *
   * The server takes NO action on this value: no per-body timer is stored,
   * nothing sweeps corpses, and no gameplay path reads it. It exists so that
   * the beat between a kill and the empty pavement is an operator setting
   * rather than a constant compiled into a shipped build.
   *
   * 0 is legitimate and means remove immediately, which is what every client
   * did before this field existed.
   *
   * @generated from field: int32 corpse_seconds = 1;
   */
  corpseSeconds: number;
};

/**
 * Describes the message police.v1.PublicConfig.
 * Use `create(PublicConfigSchema)` to create a new message.
 */
export const PublicConfigSchema: GenMessage<PublicConfig> = /*@__PURE__*/
  messageDesc(file_police_v1_police, 9);

/**
 * PoliceConfig mirrors the police_config singleton row 1:1. The BFF's
 * PATCH /admin/police/config uses the same field names so a JSON payload from
 * the admin webapp drops straight in.
 *
 * @generated from message police.v1.PoliceConfig
 */
export type PoliceConfig = Message<"police.v1.PoliceConfig"> & {
  /**
   * @generated from field: int64 bribe_price_clean = 1;
   */
  bribePriceClean: bigint;

  /**
   * @generated from field: int64 bail_price_clean = 2;
   */
  bailPriceClean: bigint;

  /**
   * @generated from field: int32 heat_threshold = 3;
   */
  heatThreshold: number;

  /**
   * @generated from field: int32 bust_heat_reset = 4;
   */
  bustHeatReset: number;

  /**
   * @generated from field: int32 guardian_alert_radius_m = 5;
   */
  guardianAlertRadiusM: number;

  /**
   * @generated from field: int32 shot_fired_heat_delta = 6;
   */
  shotFiredHeatDelta: number;

  /**
   * @generated from field: int32 pvp_kill_heat_delta = 7;
   */
  pvpKillHeatDelta: number;

  /**
   * @generated from field: double heat_mult_claim = 8;
   */
  heatMultClaim: number;

  /**
   * @generated from field: double heat_mult_intimidate = 9;
   */
  heatMultIntimidate: number;

  /**
   * @generated from field: double heat_mult_arson = 10;
   */
  heatMultArson: number;

  /**
   * @generated from field: double heat_mult_bomb = 11;
   */
  heatMultBomb: number;

  /**
   * @generated from field: int32 xp_claim = 12;
   */
  xpClaim: number;

  /**
   * @generated from field: int32 xp_intimidate = 13;
   */
  xpIntimidate: number;

  /**
   * @generated from field: int32 xp_arson = 14;
   */
  xpArson: number;

  /**
   * @generated from field: int32 xp_bomb = 15;
   */
  xpBomb: number;

  /**
   * @generated from field: int32 xp_kill = 16;
   */
  xpKill: number;

  /**
   * @generated from field: double npc_speed_mps = 17;
   */
  npcSpeedMps: number;

  /**
   * @generated from field: int32 attack_range_m = 18;
   */
  attackRangeM: number;

  /**
   * @generated from field: int32 attack_damage_hp = 19;
   */
  attackDamageHp: number;

  /**
   * @generated from field: int32 attack_tick_seconds = 20;
   */
  attackTickSeconds: number;

  /**
   * @generated from field: int32 responder_max_hp = 21;
   */
  responderMaxHp: number;

  /**
   * @generated from field: int32 guardian_max_hp = 22;
   */
  guardianMaxHp: number;

  /**
   * @generated from field: int32 responder_spawn_min_m = 23;
   */
  responderSpawnMinM: number;

  /**
   * @generated from field: int32 responder_spawn_max_m = 24;
   */
  responderSpawnMaxM: number;

  /**
   * @generated from field: int32 lost_distance_m = 25;
   */
  lostDistanceM: number;

  /**
   * @generated from field: int32 lost_seconds = 26;
   */
  lostSeconds: number;

  /**
   * @generated from field: int32 offline_seconds = 27;
   */
  offlineSeconds: number;

  /**
   * @generated from field: int32 despawn_after_lost_seconds = 28;
   */
  despawnAfterLostSeconds: number;

  /**
   * @generated from field: double bust_dirty_cash_pct = 29;
   */
  bustDirtyCashPct: number;

  /**
   * @generated from field: int64 bust_dirty_cash_min = 30;
   */
  bustDirtyCashMin: bigint;

  /**
   * @generated from field: int64 bust_dirty_cash_max = 31;
   */
  bustDirtyCashMax: bigint;

  /**
   * @generated from field: int32 bust_lay_low_seconds = 32;
   */
  bustLayLowSeconds: number;

  /**
   * @generated from field: int64 updated_at_ms = 33;
   */
  updatedAtMs: bigint;

  /**
   * @generated from field: string updated_by = 34;
   */
  updatedBy: string;

  /**
   * @generated from field: int32 guardian_respawn_seconds = 35;
   */
  guardianRespawnSeconds: number;

  /**
   * Shot heat prices a FIGHT, not a trigger pull (migration 079). Only the
   * first heat_charged_shots rounds of one (shooter, target) engagement cost
   * shot_fired_heat_delta; every round after that costs nothing, and
   * shootout_window_seconds is how long an engagement stays the same
   * engagement. The count is the SERVER's — internal/combat keeps it in Redis
   * — because a client-declared "this round is sustained" is a heat-immunity
   * switch anyone can flip.
   *
   * heat_charged_shots MAY be 0: shots never add heat at all.
   * shootout_window_seconds may NOT: a zero window expires the counter as it
   * is written, charging every round again.
   *
   * @generated from field: int32 heat_charged_shots = 36;
   */
  heatChargedShots: number;

  /**
   * @generated from field: int32 shootout_window_seconds = 37;
   */
  shootoutWindowSeconds: number;

  /**
   * How long a killed body lies on the ground on the CLIENT (migration 080).
   * Purely a presentation duration — the server stores no per-body timer and
   * reads this on no gameplay path. Also governs PLAYER corpses, not just
   * police ones: police_config is the only operator-tunable NPC/body surface
   * there is. 0 means remove immediately. Published to players through
   * GetPublicConfig; the rest of this message stays admin-only.
   *
   * @generated from field: int32 corpse_seconds = 38;
   */
  corpseSeconds: number;
};

/**
 * Describes the message police.v1.PoliceConfig.
 * Use `create(PoliceConfigSchema)` to create a new message.
 */
export const PoliceConfigSchema: GenMessage<PoliceConfig> = /*@__PURE__*/
  messageDesc(file_police_v1_police, 10);

/**
 * @generated from message police.v1.AdminGetPoliceConfigRequest
 */
export type AdminGetPoliceConfigRequest = Message<"police.v1.AdminGetPoliceConfigRequest"> & {
};

/**
 * Describes the message police.v1.AdminGetPoliceConfigRequest.
 * Use `create(AdminGetPoliceConfigRequestSchema)` to create a new message.
 */
export const AdminGetPoliceConfigRequestSchema: GenMessage<AdminGetPoliceConfigRequest> = /*@__PURE__*/
  messageDesc(file_police_v1_police, 11);

/**
 * @generated from message police.v1.AdminUpdatePoliceConfigRequest
 */
export type AdminUpdatePoliceConfigRequest = Message<"police.v1.AdminUpdatePoliceConfigRequest"> & {
  /**
   * Full replace: admin always submits the entire object. The BFF/dashboard
   * form is responsible for round-tripping unchanged fields back to the API.
   *
   * @generated from field: police.v1.PoliceConfig config = 1;
   */
  config?: PoliceConfig | undefined;
};

/**
 * Describes the message police.v1.AdminUpdatePoliceConfigRequest.
 * Use `create(AdminUpdatePoliceConfigRequestSchema)` to create a new message.
 */
export const AdminUpdatePoliceConfigRequestSchema: GenMessage<AdminUpdatePoliceConfigRequest> = /*@__PURE__*/
  messageDesc(file_police_v1_police, 12);

/**
 * @generated from service police.v1.PoliceService
 */
export const PoliceService: GenService<{
  /**
   * Player-facing.
   *
   * @generated from rpc police.v1.PoliceService.ListNpcsInCell
   */
  listNpcsInCell: {
    methodKind: "unary";
    input: typeof ListNpcsInCellRequestSchema;
    output: typeof ListNpcsInCellResponseSchema;
  },
  /**
   * Viewport query used by the Unity client's guardian loader to hydrate
   * persistent NPCs (guardians) as map tiles load, mirroring the building
   * service's ListNearbyBuildings. Reuses the ListNpcsInCellResponse shape.
   *
   * @generated from rpc police.v1.PoliceService.ListNpcsNear
   */
  listNpcsNear: {
    methodKind: "unary";
    input: typeof ListNpcsNearRequestSchema;
    output: typeof ListNpcsInCellResponseSchema;
  },
  /**
   * @generated from rpc police.v1.PoliceService.BribePolice
   */
  bribePolice: {
    methodKind: "unary";
    input: typeof BribePoliceRequestSchema;
    output: typeof BribePoliceResponseSchema;
  },
  /**
   * @generated from rpc police.v1.PoliceService.PayBail
   */
  payBail: {
    methodKind: "unary";
    input: typeof PayBailRequestSchema;
    output: typeof PayBailResponseSchema;
  },
  /**
   * The player-readable slice of police_config. Every other dial in that row
   * is admin-only on this wire, which is correct — they are the pursuit
   * simulation, and the client neither runs it nor needs to see its
   * parameters. corpse_seconds is the exception, because it is not a rule the
   * server enforces at all: it is a duration the CLIENT has to act on, so a
   * client that cannot read it has to compile in a guess.
   *
   * NOT admin-gated. Authenticated like every other player-facing RPC here,
   * and nothing more — same shape as BuildingService.GetPublicConfig and the
   * bounty/chat/family/friends/ranking twins. Cheap by construction: it reads
   * the already-cached config pointer, so no player state and no database
   * round trip, which is what makes it safe to call on every login and
   * reconnect.
   *
   * @generated from rpc police.v1.PoliceService.GetPublicConfig
   */
  getPublicConfig: {
    methodKind: "unary";
    input: typeof GetPublicConfigRequestSchema;
    output: typeof PublicConfigSchema;
  },
  /**
   * Admin (requires JWT role=admin). The dashboard webapp normally goes
   * through the BFF REST surface; these RPCs provide an alternate path for
   * grpcurl-style admin tooling.
   *
   * @generated from rpc police.v1.PoliceService.AdminGetPoliceConfig
   */
  adminGetPoliceConfig: {
    methodKind: "unary";
    input: typeof AdminGetPoliceConfigRequestSchema;
    output: typeof PoliceConfigSchema;
  },
  /**
   * @generated from rpc police.v1.PoliceService.AdminUpdatePoliceConfig
   */
  adminUpdatePoliceConfig: {
    methodKind: "unary";
    input: typeof AdminUpdatePoliceConfigRequestSchema;
    output: typeof PoliceConfigSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_police_v1_police, 0);

